import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IconsService } from 'src/app/shared/services/icons.service';
import { SettlementsService } from 'src/app/services/settlements.service';
import { CatalogsService } from 'src/app/shared/services/catalogs.service';
import { ImageService } from 'src/app/shared/services/image.service';

@Component({
  selector: '[app-tr-transactions]',
  template: `
    <td>
      <p class="mb-0"><strong># {{bill.bill_id}}</strong></p>
      <i class="text-sm text-center text-muted">{{bill.transaction_id}}</i>
    </td>
    <td>
      <p class="mb-0" style="font-size: 17px;">{{bill?.unit_name}}</p>
      <p class="mb-0 text-sm" style="font-size: 13px;">{{bill?.settlement_name}}, {{bill?.building_name}}</p>
    </td>
    <td class="text-center align-middle">
      <span class="text-danger" *ngIf="bill.consumo_lt < 0"><fa-icon [icon]="icons.faCircleExclamation"></fa-icon></span>
      {{bill.consumo_lt | number: '1.2-2'}} Lts.
    </td>
    <td class="text-center align-middle">{{bill?.amount | currency: 'USD'}}</td>
    <td class="text-center align-middle">{{bill?.due_date | date: 'dd/MM/yy'}}</td>
    <td class="text-center align-middle">{{bill?.paid_date | date: 'dd/MM/yy'}}</td>
    <td class="text-center align-middle">{{bill?.paid_date | date: 'dd/MM/yy'}}</td>
    <td class="text-end align-middle">
      <div ngbDropdown class="d-inline-block ms-2">
        <button type="button" class="btn btn-link btn-sm text-dark dropdown-toggle py-1" id="dropdownBasic2" ngbDropdownToggle >
          <fa-icon [icon]="icons.faEllipsisVertical" class="m-1"></fa-icon>
        </button>        
        <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
          <button ngbDropdownItem routerLink="/pagos/recibos/{{bill.id}}" >
            <fa-icon [icon]="icons.faEye"></fa-icon>
            Consultar recibo
          </button>
          <a ngbDropdownItem href="{{receiptUrl}}/public/{{bill.pdf}}" target="_blank" [disabled]="!bill.pdf" *ngIf="!bill.invoiced">
            <fa-icon [icon]="icons.faDownload"></fa-icon>
            Descargar recibo
          </a>
          <!-- (click)="dispatchPayment()"  *ngIf="this.bill.date_status!='expirado'" -->
          <button ngbDropdownItem (click)="downloadPaymentReceipt(bill)">
            <fa-icon [icon]="icons.faDownload"></fa-icon>
            Descargar pago
          </button>
          <button ngbDropdownItem (click)="modifyDate(bill)" *ngIf="permissions?.modules.admin.billing.modify.write">Modificar fecha de pago</button>
          <button ngbDropdownItem class="btn btn-outline-primary ms-2" *ngIf="!bill?.invoiced&&!bill.adv"  [disabled]="invoicable">Facturar</button>
          <!-- a ngbDropdownItem (click)="downloadInvoice(bill.invoice_id)" [disabled]="!bill.invoiced" *ngIf="bill.invoiced">
            <fa-icon [icon]="icons.faDownload"></fa-icon>
            Descargar factura
          </!-->
        </div>
      </div>
    </td>
  `,
  styleUrls: []
})
export class TrTransactionsComponent {
  @Input() bill: any;
  @Input() profile: any;
  @Input() permissions: any;
  @Output() updateDate = new EventEmitter<any>();

  receiptUrl: string = environment.RECIBOS_REST_WSPREFIX;
  invoicable: boolean = true;

  constructor(
    private store: SettlementsService,
    public icons: IconsService,
    public catalogs: CatalogsService,
    public images: ImageService
  ) { }

  async downloadPaymentReceipt(bill: any) {
    console.log('downloadPaymentReceipt => ', bill);


    console.log('profile => ', this.profile);

    await this.store.getTransactionByBill(bill.id).subscribe(async (transaction: any) => {

      const img = this.images.buildURL(this.profile.logo);
      const imx: any = await this.images.getBase64ImageFromUrl(img);
      this.profile.logo = `${imx.split(',')[1]}`;
    

      let payload = {
        bill: bill,
        transaction: transaction,
        profile: this.profile
      }

      console.log('payload => ', payload);

      this.store.downloadPaymentReceipt(payload).subscribe((data: any) => {
        const int8Array = new Uint8Array(data.result.data);
          const blob = new Blob([int8Array], { type: 'application/pdf' });

          var fileURL = window.URL.createObjectURL(blob);
          var link = document.createElement('a');

          link.href = fileURL;
          link.download = data.filename;
          link.click();
      });
    });
  }

  async downloadInvoice(id: any) {
    this.store.getInvoice(id).subscribe((data: any) => {
      console.log('invoice data => ', data);
      const int8Array = new Uint8Array(data.result.data);
      const blob = new Blob([int8Array], { type: 'application/pdf' });

      var fileURL = window.URL.createObjectURL(blob);

      var link = document.createElement('a');
      link.href = fileURL;
      link.download = data.filename;
      link.click();
    });
  }

  modifyDate(bill: any) {
    this.updateDate.emit(bill);
  }

}
